/**
 * Document Imports Vuex Store Module
 * State management for the document import feature.
 */

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const DOCUMENT_IMPORTS = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default DOCUMENT_IMPORTS;
